import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MsalService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';

@Component({
  selector: 'pg-sso',
  templateUrl: './pg-sso.component.html',
  styleUrls: ['./pg-sso.component.scss'],
})
export class PGSSOComponent implements OnInit, OnDestroy {
  title = 'PG SSO';
  private readonly _destroying$ = new Subject<void>();

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private authService: MsalService) {}

  ngOnInit(): void {
    this.ssologin();
  }

  ssologin() {
    const extraParams = {
      extraQueryParameters: {
        idp: 'https://fedauth.pg.com/idp/SSO.saml2',
      },
    };

    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService
          .loginPopup({
            ...this.msalGuardConfig.authRequest,
            ...extraParams,
          } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            //console.log('SSO Guard Login Popup Response:', response);
          });
      } else {
        this.authService.loginPopup().subscribe((response: AuthenticationResult) => {
          this.authService.instance.setActiveAccount(response.account);
          //console.log('SSO Login Popup Response:', response);
        });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        //console.log('SSO Guard Login Redirect');
        this.authService.loginRedirect({
          ...this.msalGuardConfig.authRequest,
          ...extraParams,
        } as RedirectRequest);
      } else {
        //console.log('SSO Login Redirect');
        this.authService.loginRedirect();
      }
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
